(() => {
  if (window.apNativeCartLoaded) return;
  window.apNativeCartLoaded = true;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let recommendationKey = '';
  let recommendationRequest = 0;
  let timerEnd = null;
  let timerInterval;
  const drawer = () => document.querySelector('.ap-native-cart');
  const strings = () => JSON.parse(drawer().querySelector('[data-ap-strings]').textContent);
  const money = value => window.theme.formatMoney(value, window.theme.moneyFormat);
  const state = () => {
    const node = drawer()?.querySelector('[data-items-holder] [data-ap-state]');
    return node ? JSON.parse(node.textContent) : { count: 0, total: 0, savings: 0, products: [] };
  };
  const post = async (url, data) => {
    const response = await fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
    const result = await response.json();
    if (!response.ok || result.errors) throw new Error(typeof result.description === 'string' ? result.description : strings().error);
    return result;
  };
  function error(message) {
    let node = drawer().querySelector('[data-ap-error]');
    if (!node) { node = document.createElement('p'); node.dataset.apError = ''; node.setAttribute('role', 'alert'); drawer().querySelector('.drawer__body').prepend(node); }
    node.textContent = message;
  }
  function clearError() { drawer()?.querySelector('[data-ap-error]')?.remove(); }
  function update() {
    const el = drawer();
    if (!el) return;
    const data = state();
    if (!data.count) { clearInterval(timerInterval); timerInterval = null; timerEnd = null; try { sessionStorage.removeItem("ap-native-cart-timer"); } catch {} }
    const text = strings();
    el.querySelector('[data-ap-checkout-price]').textContent = money(data.total);
    const referenceTotal = data.total + data.savings;
    const savingsPercent = referenceTotal > 0 ? Math.round(data.savings / referenceTotal * 100) : 0;
    const savingsAmount = document.createTextNode('-' + money(data.savings) + ' ');
    const savingsBadge = document.createElement('span');
    savingsBadge.className = 'ap-saving-percent';
    savingsBadge.textContent = '(' + savingsPercent + '%)';
    el.querySelector('[data-ap-savings]').replaceChildren(savingsAmount, savingsBadge);
    el.querySelector('.ap-saving').hidden = data.savings <= 0;
    const progressMessage = el.querySelector('[data-ap-progress-message]');
    const message = text.messages[Math.max(0, Math.min(3, data.count - 1))];
    const messageParts = message.split(/(\d+(?:[.,]\d+)?\s*%?)/g);
    progressMessage.replaceChildren(...messageParts.map(part => {
      if (/^\d/.test(part)) {
        const strong = document.createElement('strong');
        strong.textContent = part;
        return strong;
      }
      return document.createTextNode(part);
    }));
    el.querySelector('[data-ap-fill]').style.width = (data.count <= 0 ? 0 : data.count === 1 ? 15 : data.count === 2 ? 30 : data.count === 3 ? 60 : 90) + '%';
    el.querySelectorAll('[data-goal]').forEach(node => { const goal = Number(node.dataset.goal); node.classList.toggle('unlocked', data.count >= goal); node.classList.toggle('current', data.count + 1 === goal); });
    el.querySelectorAll('.ap-line-variant').forEach(node => { node.hidden = false; });
    const label = el.querySelector('.cart__total:last-of-type .cart__total__label');
    if (label) label.textContent = text.subtotal;
    el.querySelectorAll('[data-cart-total]').forEach(node => { node.textContent = money(data.total); });
    el.querySelector('.ap-checkout').disabled = busy || data.count === 0;
    el.querySelectorAll('.cart__quantity-minus').forEach(button => { const qty = Number(button.closest('[data-item]').querySelector('input[name="updates[]"]').value); button.disabled = qty <= 1 || busy; });
    if (el.classList.contains('is-open')) { startTimer(); loadRecommendations(); }
  }
  function startTimer() {
    if (!drawer() || state().count === 0) return;
    if (timerEnd === null) {
      try { timerEnd = Number(sessionStorage.getItem('ap-native-cart-timer')) || Date.now() + 600000; sessionStorage.setItem('ap-native-cart-timer', String(timerEnd)); }
      catch { timerEnd = Date.now() + 600000; }
    }
    const tick = () => {
      if (timerEnd <= Date.now()) {
        timerEnd = Date.now() + 600000;
        try { sessionStorage.setItem('ap-native-cart-timer', String(timerEnd)); } catch {}
      }
      const remaining = Math.ceil((timerEnd - Date.now()) / 1000);
      const node = drawer()?.querySelector('[data-ap-timer]');
      if (!node) { clearInterval(timerInterval); timerInterval = null; return; }
      node.hidden = false;
      node.querySelector('[data-ap-time]').textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
    };
    tick();
    if (!timerInterval && Date.now() < timerEnd) timerInterval = setInterval(tick, 1000);
  }
  function card(product) {
    const available = product.variants.filter(variant => variant.available);
    if (!available.length) return null;
    const item = document.createElement('article'); item.className = 'ap-product-card';
    const imageLink = document.createElement('a'); imageLink.href = product.url; imageLink.className = 'ap-product-image';
    if (product.featured_image) { const img = document.createElement('img'); img.src = product.featured_image; img.alt = product.title; img.width = 80; img.height = 96; img.loading = 'lazy'; imageLink.append(img); }
    const info = document.createElement('div'); info.className = 'ap-product-info';
    const name = document.createElement('a'); name.href = product.url; name.className = 'ap-product-name'; name.textContent = product.title;
    const form = document.createElement('form'); form.action = root + 'cart/add'; form.method = 'post'; form.dataset.apAddForm = '';
    const select = document.createElement('select'); select.name = 'id'; select.setAttribute('aria-label', product.title);
    for (const variant of product.variants) { const option = document.createElement('option'); option.value = variant.id; option.textContent = variant.title; option.disabled = !variant.available; option.dataset.price = variant.price; option.dataset.compare = variant.compare_at_price || 0; select.append(option); }
    select.value = String(available[0].id);
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') select.hidden = true;
    const bottom = document.createElement('div'); bottom.className = 'ap-product-bottom';
    const prices = document.createElement('div'); const price = document.createElement('span'); price.dataset.apCardPrice = ''; const compare = document.createElement('del'); compare.dataset.apCardCompare = ''; prices.append(price, compare);
    const button = document.createElement('button'); button.type = 'submit'; button.textContent = '+ ' + strings().add;
    bottom.append(prices, button); form.append(select, bottom); info.append(name, form); item.append(imageLink, info); updateCard(select); return item;
  }
  function updateCard(select) {
    const option = select.selectedOptions[0];
    const form = select.closest('form');
    if (!option?.dataset.price) return;
    const price = Number(option.dataset.price); const compare = Number(option.dataset.compare);
    form.querySelector('[data-ap-card-price]').textContent = money(price);
    form.querySelector('[data-ap-card-compare]').textContent = compare > price ? money(compare) : '';
  }
  async function loadRecommendations() {
    const el = drawer(); if (!el) return;
    const data = state(); const key = data.products.join(',');
    if (!data.count) { recommendationKey = ''; el.querySelector('[data-ap-related]').hidden = true; return; }
    if (recommendationKey === key) return;
    recommendationKey = key; const request = ++recommendationRequest;
    if (data.women) {
      const template = el.querySelector('[data-items-holder] [data-ap-curated]');
      const target = el.querySelector('[data-ap-cards]');
      target.replaceChildren(...(template ? [...template.content.children].map(node => node.cloneNode(true)) : []));
      el.querySelector('[data-ap-related]').hidden = !target.children.length;
      return;
    }
    try {
      const response = await fetch(root + 'recommendations/products.json?product_id=' + data.products[0] + '&limit=10&intent=related');
      if (!response.ok) throw new Error();
      const result = await response.json();
      if (request !== recommendationRequest || !drawer() || state().products.join(',') !== key) return;
      const cards = result.products.filter(product => !data.products.includes(product.id)).map(card).filter(Boolean);
      el.querySelector('[data-ap-cards]').replaceChildren(...cards); el.querySelector('[data-ap-related]').hidden = !cards.length;
    } catch { recommendationKey = ''; el.querySelector('[data-ap-related]').hidden = true; }
  }
  function refresh() { document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); }
  async function add(form) {
    if (busy || drawer().classList.contains('is-loading')) return;
    busy = true; clearError();
    const button = form.querySelector('button[type="submit"]'); button.disabled = true; update();
    try { await post('cart/add.js', { items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] }); refresh(); }
    catch (err) { error(err.message); }
    finally { busy = false; button.disabled = false; update(); }
  }
  async function changeVariant(select) {
    const data = JSON.parse(select.parentElement.querySelector('[data-ap-line]').textContent);
    if (busy || drawer().classList.contains('is-loading')) { select.value = String(data.id); return; }
    busy = true; clearError(); select.disabled = true; update();
    let added;
    let priorQuantity = 0;
    try {
      const beforeResponse = await fetch(root + 'cart.js'); if (!beforeResponse.ok) throw new Error(strings().error);
      const before = await beforeResponse.json();
      const properties = Array.isArray(data.properties) ? Object.fromEntries(data.properties) : data.properties || {};
      const item = { id: Number(select.value), quantity: data.quantity, properties };
      if (data.selling_plan) item.selling_plan = data.selling_plan;
      const result = await post('cart/add.js', { items: [item] }); added = result.items[0];
      priorQuantity = before.items.find(line => line.key === added.key)?.quantity || 0;
      const afterResponse = await fetch(root + 'cart.js');
      if (!afterResponse.ok) throw new Error(strings().error);
      const after = await afterResponse.json();
      const sameProperties = line => JSON.stringify(Object.entries(line.properties || {}).sort()) === JSON.stringify(Object.entries(properties).sort());
      const original = after.items.find(line => line.variant_id === data.id && sameProperties(line) && (line.selling_plan_allocation?.selling_plan?.id || null) === data.selling_plan);
      if (!original) throw new Error(strings().error);
      await post('cart/change.js', { id: original.key, quantity: 0 });
    } catch (err) {
      if (added) { try { await post('cart/change.js', { id: added.key, quantity: priorQuantity }); } catch {} }
      error(err.message); select.value = String(data.id);
    } finally { busy = false; select.disabled = false; refresh(); update(); }
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('.ap-native-cart [data-ap-add-form]');
    if (form) { event.preventDefault(); event.stopPropagation(); add(form); }
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.closest('.ap-native-cart')) return;
    if (event.target.matches('[data-ap-variant]')) changeVariant(event.target);
    else if (event.target.matches('[data-ap-add-form] select')) updateCard(event.target);
  });
  document.addEventListener('click', event => {
    const el = drawer(); if (!el?.contains(event.target)) return;
    const prev = event.target.closest('[data-ap-prev]'); const next = event.target.closest('[data-ap-next]');
    if (prev || next) { const cards = el.querySelector('[data-ap-cards]'); cards.scrollBy({ left: (next ? 1 : -1) * (cards.clientWidth + 10), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }
    if (event.target.closest('.cart__quantity-minus')) { const qty = Number(event.target.closest('[data-item]').querySelector('input[name="updates[]"]').value); if (qty <= 1 || busy) { event.preventDefault(); event.stopImmediatePropagation(); } }
  }, true);
  document.addEventListener('theme:cart:change', () => { update(); queueMicrotask(update); });
  document.addEventListener('theme:product:added', update);
  document.addEventListener('theme:cart-drawer:open', () => { update(); startTimer(); loadRecommendations(); });
  document.addEventListener('shopify:section:load', () => { recommendationKey = ''; update(); });
  update();
})();
